export interface Category {
  name: string;
  slug: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    name: '情感故事',
    slug: 'qinggan-gushi',
    description: '真实动人的情感经历与故事分享，记录女性之间温暖的情感连接与心灵触动。',
    icon: 'ri-heart-line',
  },
  {
    name: '日常生活',
    slug: 'richang-shenghuo',
    description: '记录女女伴侣的日常点滴，从柴米油盐到温馨陪伴，平凡生活中的不平凡。',
    icon: 'ri-home-line',
  },
  {
    name: '相处之道',
    slug: 'xiangchu-zhidao',
    description: '探讨女女关系中的沟通技巧、矛盾化解与长久相处之道，建立健康的亲密关系。',
    icon: 'ri-chat-heart-line',
  },
  {
    name: '真实体验',
    slug: 'zhenshi-tiyan',
    description: '来自真实读者的亲身经历与感悟，第一人称视角的真诚分享，让你不再孤单。',
    icon: 'ri-user-heart-line',
  },
  {
    name: '情感共鸣',
    slug: 'qinggan-gongming',
    description: '深度解读女性情感世界，探索爱与理解的本质，在这里找到属于你的情感共鸣。',
    icon: 'ri-empathize-line',
  },
  {
    name: '成长记录',
    slug: 'chengzhang-jilu',
    description: '在关系中成长，在爱中蜕变。记录每一次心灵的成长与自我发现的旅程。',
    icon: 'ri-seedling-line',
  },
];